import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=ed777c24&scoped=true&"
import script from "./js/detail.js?vue&type=script&lang=js&"
export * from "./js/detail.js?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=ed777c24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed777c24",
  null
  
)

export default component.exports